module.exports = __webpack_public_path__ + "img/flamethrower.b5dcb8b3.png";